import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import { LinkTo } from '@ember/routing'
import { ErrorsImageUnexpected } from 'teacher-ui-client/components/errors/image-unexpected'

interface Signature {
  Element: HTMLDivElement
}

export const ErrorsStudentImportPage: TOC<Signature> = <template>
  <div data-test-errors-student-import-page class="text-dusty-black-300 space-y-2 text-center" ...attributes>
    <ErrorsImageUnexpected />
    <h2 data-test-student-import-title>
      {{t "components.errors.studentImport.title"}}
    </h2>
    <p class="text-xl" data-test-student-import-body>
      {{t "components.errors.studentImport.body" htmlSafe=true}}
      <LinkTo @route="subscription-type.contact-us">{{t "components.errors.studentImport.link"}}</LinkTo>
    </p>
  </div>
</template>

export default ErrorsStudentImportPage
